import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import { Headline } from "../section/Headline"
import { Container } from "../layout/Container"
import { Image } from "../image/Image"

export function OffsetTextGrid({
  title,
  description,
  containerProps = {},
  textGrid,
}) {
  return (
    <Container
      id={title && title.toLowerCase()?.split(" ").join("-")}
      {...containerProps}
    >
      <Box mb="60px">
        <Headline title={title} description={description} />
      </Box>

      <Flex flexWrap="wrap">
        {textGrid.map(({ text, image }, index) => {
          return (
            <Box
              flex={{ base: `0 0 100%`, md: "0 0 50%" }}
              mt={{ base: 0, md: index % 2 === 0 ? "0" : "100px" }}
              mb={{ base: `30px`, md: 0 }}
            >
              <Box
                textAlign={index % 2 === 0 ? "left" : "right"}
                maxWidth={{ base: `100%` }}
                margin={{
                  base: index % 2 === 0 ? "0 0 auto 0" : "auto 0 auto auto",
                }}
              >
                <Image image={image?.localFile} />
              </Box>
              <Box maxW="527px" mt="16px">
                <Text
                  textAlign={index % 2 === 0 ? "left" : "right"}
                  fontSize={{ base: `16px`, md: "24px" }}
                  color="black"
                  lineHeight={{ base: `22px`, md: "32px" }}
                >
                  {text}
                </Text>
              </Box>
            </Box>
          )
        })}
      </Flex>
    </Container>
  )
}
